var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pre-selections"},_vm._l((_vm.values),function(item){return _c('AlcorButton',{staticClass:"selection-button",on:{"click":function($event){return _vm.handleSelect(item)}}},[_c('span',{staticClass:"fs-10 disable"},[_vm._v(_vm._s(item)+" %")])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }